import { isMobile } from 'react-device-detect'

/* eslint-disable */
console.groupCollapsed('\n🌿 Nooro\n\n')
console.log('🌎https://tastefullymade.com/')
console.groupEnd()
/* eslint-enable */

function setViewport() {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

setViewport()

if (!isMobile) {
  window.addEventListener('resize', setViewport)
}
